import { useContext, useEffect, useRef, useState } from "react";
import TenantAuth from "./TenantAuth";
import constants from "../../Utils/constants";
import useTranslator from "../../hooks/useTranslator";
import AuthContext from "../../context/auth/AuthContext";
import i18next from "i18next";
import { haveValue, toast } from "../../helper/common";
import axios from "axios";
import { useCookies } from "react-cookie";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TenantContext from "../../context/tenant/TenantContext";
import LandLordContext from "../../context/landlord/LandLordContext";
import LandlordAuth from "./LandlordAuth";
import SwitchUserConfirmationModal from "../../components/SwitchUserConfirmationModal";
import socket from "../../socket";
import { trackClarityEvent } from "../../Utils/clarityReady";

const UserAuth = ({ isDummySignup }) => {
  const { _t } = useTranslator();

  const { getUserByEmail, sendOTPES, sendOTP, loadUser } =
    useContext(AuthContext);
  const { shareProfile } = useContext(TenantContext);
  const { getWorkspaceDetailsFromSlug } = useContext(LandLordContext);
  const navigate = useNavigate();
  const queryParameters = new URLSearchParams(window.location.search);
  const workspaceUuid = queryParameters.get("wid");
  const [from, setFrom] = useState(null);
  const [landlordsData, setLandlordsData] = useState({});

  useEffect(() => {
    const from = queryParameters.get("from");

    if (from) {
      setFrom(from);
      queryParameters.delete("from");
      const newUrl =
        window.location.pathname +
        (queryParameters.toString() ? "?" + queryParameters.toString() : "");
      window.history.replaceState({}, "", newUrl);
    }
  }, []);

  const [userLogin, setUserLogin] = useState({
    _id: null,
    email: "",
    password: "",
    confirmPassword: "",
    type: "tenant",
    checkedTenant: true,
    checkedLandlord: false,
    user_type:
      window.location.hostname === "alquilatuhogar.skortorent.com"
        ? constants.MACC
        : constants.SKOR,
    checked: false,
    qrCode_signup: false,
    analysisCompleted: true,
    requestProfileLink: null,
    fname: "",
    fname_companyName: "",
    lname: "",
    fname: "",
    identity_number: "",
    post_code: "",
    dob: "",
    employment_status: "",
    employment_category: "",
    current_annual_income: "",
    protected_housing: false,
    phone_number: "",
    phone: "",
    currency: "EUR",
    company_legal_name: "",
    company_cif: "",
    company_type: "",
    company_cnae: "",
    company_representative_position: "",
  });
  const [disabled, setDisabled] = useState(false);
  const [isUserVerified, setIsUserVerified] = useState(false);
  const [presentUserData, setPresentUserData] = useState({});
  const [userAlreadyExists, setUserAlreadyExists] = useState(false);
  const [currentScreen, setCurrentScreen] = useState("emailScreen");
  const [cookies, setCookie, removeCookie] = useCookies([
    "sharedProfileLink",
    "requestProfileLink",
  ]);
  const [authAction, setAuthAction] = useState("login");
  const [currentLoginScreen, setCurrentLoginScreen] = useState("tenant");
  const { pathname } = useLocation();
  const [companyLogo, setCompanyLogo] = useState(null);
  const { workspace_slug } = useParams();
  const [verifyOtpLoading, setVerifyOtpLoading] = useState(false);
  const [showUserExistsPopup, setShowUserExistsPopup] = useState(false);
  const [switchUserData, setSwitchUserData] = useState({});

  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("i18nextLng").toLowerCase() || "es"
  );

  useEffect(() => {
    setCurrentLang(localStorage.getItem("i18nextLng").toLowerCase() || "es");
  }, [localStorage.getItem("i18nextLng")]);

  const handleLanguageChange = async (langVal) => {
    await i18next.changeLanguage(langVal);
    setCurrentLang(langVal);
  };

  useEffect(() => {
    const userLangChange = async () => {
      if (
        haveValue(queryParameters.get("lng")) &&
        queryParameters.get("lng") == "es"
      ) {
        await i18next.changeLanguage("es");
        setCurrentLang("es");
      } else if (
        haveValue(localStorage.getItem("i18nextLng")) &&
        localStorage.getItem("i18nextLng") == "es"
      ) {
        await i18next.changeLanguage("es");
        setCurrentLang("es");
      } else if (
        haveValue(localStorage.getItem("i18nextLng")) &&
        localStorage.getItem("i18nextLng") == "en-us"
      ) {
        await i18next.changeLanguage("en-us");
        setCurrentLang("en-us");
      } else {
        await i18next.changeLanguage("es");
        setCurrentLang("es");
      }
    };
    userLangChange();
    if (pathname === "/tenant/auth") {
      localStorage.setItem("usertype", "tenant");
      setCurrentLoginScreen("tenant");
      setUserLogin((prev) => ({
        ...prev,
        checkedLandlord: false,
        checkedTenant: true,
        type: "tenant",
      }));
    } else if (pathname === "/guarantor/auth") {
      localStorage.setItem("usertype", "tenant");
      setCurrentLoginScreen("tenant");
      setUserLogin((prev) => ({
        ...prev,
        checkedLandlord: false,
        checkedTenant: true,
        type: "tenant",
      }));
    } else if (pathname === "/landlord/auth") {
      localStorage.setItem("usertype", "landlord");
      setCurrentLoginScreen("landlord");
      setUserLogin((prev) => ({
        ...prev,
        checkedLandlord: true,
        checkedTenant: false,
        type: "landlord",
      }));
    } else {
      localStorage.setItem("usertype", "tenant");
      setCurrentLoginScreen("tenant");
      setUserLogin((prev) => ({
        ...prev,
        checkedLandlord: false,
        checkedTenant: true,
        type: "tenant",
      }));
    }
  }, [pathname]);

  // workspace_slug is not using for now (It is shifted to customLinkAuthCheck component) only workspaceUuid is using, will change it later
  useEffect(() => {
    if (haveValue(workspace_slug) || haveValue(workspaceUuid)) {
      getWorkspaceDetailsFromSlug(workspace_slug, workspaceUuid)
        .then((res) => {
          const data = res.data;
          if (data.status == "Success") {
            if (
              data?.data?.customLinkEnabled &&
              haveValue(data?.data?.customLinkSlug)
            ) {
              navigate(`/oauth/${data?.data?.customLinkSlug}`);
              if (
                localStorage.getItem("usertype") == "tenant" &&
                haveValue(data?.data?.landlord_id)
              ) {
                setCookie(
                  "requestProfileLink",
                  `${data?.data?.landlord_id}_${data?.data?.uuid}`,
                  {
                    path: "/",
                    maxAge: 604800,
                  }
                );
              }
              setCompanyLogo(data?.data?.invitationLogo);
            } else {
              if (haveValue(data?.data?.invitationLogo)) {
                setCompanyLogo(data?.data?.invitationLogo);
              }
              const url = new URL(window.location.href);
              url.searchParams.delete("wid");

              window.history.replaceState(
                {},
                document.title,
                url.pathname + url.search
              );
            }
            if (data?.data?.catella_rules_activated) {
              setCookie("catellaWorkspaceTenant", `${data?.data?.uuid}`, {
                path: "/",
                maxAge: 3600,
              });
            }
            if (data?.data?.libeen_rules_activated) {
              setCookie("libeenWorkspaceTenant", `${data?.data?.uuid}`, {
                path: "/",
                maxAge: 3600,
              });
            }
            setLandlordsData(data?.data);
          }
        })
        .catch((err) => {
          console.log(err, "Error in getWorkspaceDetailsFromSlug");
        });
    }
  }, [workspace_slug, workspaceUuid]);

  const saveCookieInStateThing = () => {
    if (
      haveValue(cookies.requestProfileLink) &&
      localStorage.getItem("usertype") == "tenant"
    ) {
      setUserLogin((prev) => ({
        ...prev,
        qrCode_signup: true,
        requestProfileLink: haveValue(cookies.requestProfileLink)
          ? cookies.requestProfileLink
          : null,
      }));
    } else {
      console.log("cookie not found, or user type not found");
    }
  };

  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
    const temp_var = queryParameters.get("profile_done");
    if (haveValue(temp_var)) {
      setCurrentScreen("llBasicInfo");
    }
  }, []);

  useEffect(() => {
    if (isClient) {
      setTimeout(() => {
        saveCookieInStateThing();
      }, 2000);
    }
  }, [isClient]);

  useEffect(() => {
    saveCookieInStateThing();
  }, [cookies?.requestProfileLink]);

  // otp functionality
  let timer = 60;
  const intervalRef = useRef(null);
  const [otp, setOtp] = useState("");
  const [showResend, setShowResend] = useState(false);
  const [showTimer, setShowTimer] = useState(timer);

  const validateEmail = (mail) => {
    const emailRegex = /^[\p{L}\p{N}._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/u;
    if (emailRegex.test(mail)) {
      return true;
    }
    toast.error(_t("invalidEmailAddress"));
    return false;
  };

  const runTimer = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    intervalRef.current = setInterval(() => {
      setShowTimer((prev) => {
        if (prev > 0) {
          return prev - 1;
        } else {
          resetTimer();
          return 0;
        }
      });
    }, 1000);
  };

  const resetTimer = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
    setShowResend(true);
    setShowTimer(60);
  };

  const sendOtpFun = (user_id) => {
    if (isDummySignup) {
      resetTimer();
      setShowResend(false);
      runTimer();
      return;
    }
    resetTimer();
    const usertype = localStorage.getItem("usertype");
    if (currentLang === "es") {
      sendOTPES(userLogin?.email, usertype);
    } else {
      sendOTP(userLogin?.email, usertype);
    }
    setOtp("");
    setShowResend(false);
    runTimer();
  };

  const emailSubmitHandler = async (event) => {
    event.preventDefault();

    let email = userLogin.email;
    let type = userLogin.type;

    //validate email
    if (!validateEmail(email)) {
      return;
    }

    if (isDummySignup) {
      navigate("/demo/onboarding");
      return;
    }

    try {
      setDisabled(true);
      const response = await getUserByEmail({ email, type });
      if (response) {
        if (haveValue(cookies?.invitationToken)) {
          removeCookie("invitationToken", { path: "/" });
        }

        const user = response.user;
        if (user) {
          setUserLogin((prev) => {
            return {
              ...prev,
              _id: user._id,
            };
          });

          //set user is verified
          setIsUserVerified(user.verified === true ? true : false);
          setPresentUserData(user);
          setUserAlreadyExists(true);

          //show otp screen
          if (
            localStorage.getItem("usertype") == "landlord" &&
            user.verified === true
          ) {
            setCurrentScreen("loginWithCredentials");
          } else {
            sendOtpFun();
            setCurrentScreen("verifyOTP");
          }

          runTimer();
        } else {
          // check if user exists in db
          const userType = type === "tenant" ? "landlord" : "tenant";
          const response2 = await getUserByEmail({ email, type: userType });

          const user = response2?.user;
          if (user) {
            setSwitchUserData(response2);
            setShowUserExistsPopup(true);
          } else {
            setCurrentScreen("registerUser");
            setAuthAction("register");
            if (type === "tenant") {
              trackClarityEvent("tenant_onboarding_started");
              setTimeout(() => {
                trackClarityEvent("tenant_basic_info_step_started");
              }, constants.CLARITY_DELAY);
            } else {
              trackClarityEvent("landlord_onboarding_started");
              setTimeout(() => {
                trackClarityEvent("landlord_password_step_started");
              }, constants.CLARITY_DELAY);
            }
          }
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setDisabled(false);
    }
  };

  const onChangeHandler = (event) => {
    if (event.target.name === "email") {
      sessionStorage.setItem("dummy_email", event.target.value.toLowerCase());
      setUserLogin({
        ...userLogin,
        [event.target.name]: event.target.value.toLowerCase(),
      });
    } else {
      setUserLogin({
        ...userLogin,
        [event.target.name]: event.target.value,
      });
    }
  };

  const verifyOtpHandler = async (event, createUser) => {
    event.preventDefault();

    if (isDummySignup && otp.length === 6) {
      navigate("/demo/onboarding");
      return;
    }

    try {
      if (haveValue(otp) && otp.length === 6) {
        setVerifyOtpLoading(true);
        const response = await axios.put(
          `${process.env.REACT_APP_SERVER_URL}/users/otp-verify/${userLogin.email}`,
          { type: userLogin.type, otp: otp },
          {
            headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
          }
        );
        if (response.data) {
          if (authAction === "login" && isUserVerified) {
            redirectFun(response.data);
          } else {
            const usertype = localStorage.getItem("usertype");
            if (response.data.status === "verified") {
              if (!haveValue(response?.data?.user?.email)) {
                await createUser?.();
              }
              const token = response?.data?.token;
              const saveduserid = response?.data?.user?._id;
              const external_customer_id = response?.data?.user?._id;

              if (!haveValue(token)) {
                toast.error(_t("loginFailed"));
                return;
              }

              localStorage.setItem("token", token);
              localStorage.setItem("is_verified", true);
              localStorage.setItem("saveduserid", saveduserid);
              localStorage.setItem(
                "external_customer_id",
                external_customer_id
              );

              loadUser(usertype);
              if (
                haveValue(cookies.sharedProfileLink) &&
                usertype === "landlord"
              ) {
                if (haveValue(response?.data?.user?._id)) {
                  shareProfile(
                    cookies.sharedProfileLink,
                    response?.data?.user?._id,
                    "null",
                    "full",
                    { shareType: "tLink" }
                  )
                    .then((res) => {
                      removeCookie("sharedProfileLink", { path: "/" });
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                }
              }
              if (
                response?.data?.user?.role === "tenant" ||
                usertype === "tenant"
              ) {
                navigate(
                  response?.data?.user?.profile_completed
                    ? "/home"
                    : "/onboarding?welcome=true"
                );
              }
            }
          }
        }
      } else {
        console.log("ERROR HERE");
        throw new Error(_t("invalidOtp"));
      }
    } catch (error) {
      let serverResponse = error;
      toast.error(serverResponse.response.data.errormsg || _t("invalidOtp"));
    } finally {
      setDisabled(false);
      setVerifyOtpLoading(false);
    }
  };

  const redirectFun = (data) => {
    //LogIn Message
    toast.success(_t("loggedInSuccessfully"));

    const token = data.token;
    const is_verified = true;
    const usertype = localStorage.getItem("usertype");
    const saveduserid = data.user._id;
    const external_customer_id = data.user._id;
    const user = data.user;

    if (window.location.host === process.env.REACT_APP_MACC_URL_NAME) {
      if (token && is_verified) {
        const app_type = "macc";
        // Create a query string from the constants
        const queryParams = new URLSearchParams({
          token: token || "", // Append token
          usertype: usertype || "", // Append usertype
          is_verified: is_verified || "", // Append is_verified
          saveduserid: saveduserid || "", // Append saveduserid
          external_customer_id: external_customer_id || "", // Append external_customer_id
          app_type: app_type || "", // // Append app_type
        });
        // Redirect to the new URL with query parameters
        document.body.innerHTML = "";
        window.location.replace(
          `${window.location.protocol}//${
            process.env.REACT_APP_URL_NAME
          }/redirect?${queryParams.toString()}`
        );
        return false;
      }
    }

    //share profile
    if (haveValue(cookies.sharedProfileLink) && userLogin.type === "landlord") {
      if (haveValue(data?.user?._id)) {
        shareProfile(
          cookies.sharedProfileLink,
          data?.user?._id,
          "null",
          "full",
          { shareType: "tLink" }
        )
          .then((res) => {
            if (res?.success) {
              toast.success(_t("profileImported"));
            } else {
              toast.error(res?.errormsg ?? _t("failedToGetProfile"));
            }
            removeCookie("sharedProfileLink", { path: "/" });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }

    //Set Local Storage
    localStorage.setItem("token", token);
    localStorage.setItem("is_verified", true);
    localStorage.setItem("saveduserid", saveduserid);
    localStorage.setItem("external_customer_id", external_customer_id);

    loadUser(userLogin.type);

    if (user.role === "tenant" || usertype === "tenant") {
      navigate(user.profile_completed ? "/home" : "/onboarding?welcome=true");
    } else {
      socket.emit("join_landlord_room", saveduserid);
      if (user?.has_profile && user?.profile_completed) {
        navigate(`/workspace-dashboard`);
      } else if (user?.has_profile) {
        setCurrentScreen("llOnboardingStep");
      } else {
        setCurrentScreen("llBasicInfo");
      }
    }
  };

  const handleChangeUser = () => {
    const oppositeType = userLogin.type === "tenant" ? "landlord" : "tenant";

    navigate(`/${oppositeType}/auth`);
    setShowUserExistsPopup(false);
    if (switchUserData) {
      localStorage.setItem("usertype", oppositeType);
      const user = switchUserData.user;
      if (user) {
        setUserLogin((prev) => {
          return {
            ...prev,
            _id: user._id,
            type: oppositeType,
          };
        });

        //set user is verified
        setIsUserVerified(user.verified === true ? true : false);
        setPresentUserData(user);
        setUserAlreadyExists(true);

        //show otp screen
        if (
          localStorage.getItem("usertype") == "landlord" &&
          user.verified === true
        ) {
          setCurrentScreen("loginWithCredentials");
        } else {
          sendOtpFun();
          setCurrentScreen("verifyOTP");
        }

        runTimer();
      }
    }
  };

  let strongPassword = new RegExp(
    "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})"
  );

  return (
    <>
      <div>
        {currentLoginScreen === "landlord" ? (
          <LandlordAuth
            currentLang={currentLang}
            currentScreen={currentScreen}
            handleLanguageChange={handleLanguageChange}
            emailSubmitHandler={emailSubmitHandler}
            onChangeHandler={onChangeHandler}
            userLogin={userLogin}
            setUserLogin={setUserLogin}
            disabled={disabled}
            setDisableButton={setDisabled}
            setCurrentScreen={setCurrentScreen}
            validateEmail={validateEmail}
            strongPassword={strongPassword}
            runTimer={runTimer}
            sendOtpFun={sendOtpFun}
            otp={otp}
            setOtp={setOtp}
            showResend={showResend}
            showTimer={showTimer}
            verifyOtpHandler={verifyOtpHandler}
            redirectFun={redirectFun}
            userAlreadyExists={userAlreadyExists}
            verifyOtpLoading={verifyOtpLoading}
            from={from}
          />
        ) : (
          <TenantAuth
            emailSubmitHandler={emailSubmitHandler}
            onChangeHandler={onChangeHandler}
            disabled={disabled}
            currentScreen={currentScreen}
            setCurrentScreen={setCurrentScreen}
            sendOtpFun={sendOtpFun}
            otp={otp}
            setOtp={setOtp}
            showResend={showResend}
            showTimer={showTimer}
            currentLang={currentLang}
            handleLanguageChange={handleLanguageChange}
            verifyOtpHandler={verifyOtpHandler}
            userLogin={userLogin}
            setUserLogin={setUserLogin}
            validateEmail={validateEmail}
            strongPassword={strongPassword}
            runTimer={runTimer}
            companyLogo={companyLogo}
            user_type={userLogin?.user_type}
            redirectFun={redirectFun}
            verifyOtpLoading={verifyOtpLoading}
            from={from}
            landlordsData={landlordsData}
            isDummySignup={isDummySignup}
          />
        )}
      </div>
      {showUserExistsPopup && (
        <SwitchUserConfirmationModal
          email={userLogin.email}
          type={userLogin?.type}
          onClose={() => {
            setCurrentScreen("registerUser");
            setAuthAction("register");
            setShowUserExistsPopup(false);
          }}
          handleChangeUser={handleChangeUser}
        />
      )}
    </>
  );
};

export default UserAuth;
